const CryptoJS = require('crypto-js');

const ENC_KEY = "krpd34i1"
const ENC_IV = "r3fb8eot"
let security_EncriptResponse = true;//开启对后端返回的reponse的解密
let security_EncriptRequest = true;//开启 POST 类型的request body 加密 
let security_VerifyGET = true;//开启GET类型的ajax请求的querystring的签名验签
// let security_WhiteListUrl = ['/AbpUserConfiguration/GetAll','/api/TokenAuth/Authenticate','/api/services/app/Session/GetCurrentLoginInformations']; //白名单
const security_WhiteListUrl = []; //白名单

// let isEncrypted = process.env.NODE_ENV === 'development';
let isEncrypted = window.abp.isEncrypted 

if (!isEncrypted) {
    console.log('开发环境');
    security_EncriptResponse = false;
    security_EncriptRequest = false;
    security_VerifyGET = false;
} else if (process.env.NODE_ENV === 'production') {
    console.log('生产环境');
    // isEncrypted = false;
    security_EncriptResponse = true;
    security_EncriptRequest = true;
    security_VerifyGET = true;
}
function decryptData(data) {
        let encryptedData = data;
        console.log(CryptoJS);
        let key = CryptoJS.enc.Utf8.parse(ENC_KEY);
        let iv = CryptoJS.enc.Utf8.parse(ENC_IV);
        let decrypted = CryptoJS.DES.decrypt(
            encryptedData,
            key,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        data = decrypted.toString(CryptoJS.enc.Utf8);
        data = JSON.parse(data)

    return data;
}
//判断白名单存在
function isTextEndsWithWhiteList(resquestUrl) {
    if (!Array.isArray(security_WhiteListUrl) || security_WhiteListUrl.length === 0) {
        return false;
    }
    for (const url of security_WhiteListUrl) {
        if (resquestUrl.endsWith(url)) {
            return true;
        }
    }
    return false;
}
export { decryptData, isTextEndsWithWhiteList, ENC_KEY, ENC_IV, security_EncriptResponse, security_EncriptRequest, security_VerifyGET, security_WhiteListUrl };